import React, { Component } from 'react';
import Content_Area from './Components/Content_Area/Content_Area';
import './App.css';
import App_Receiver from './App_Interface/App_Receiver';
import loading from './Images/loading2_invert_colours.gif';

import { isEmpty } from './Components/Common/Common.js';
//import Console from './Components/Common/Console';
import { Colours } from './Components/Common/colours.js';

export default class App extends Component {
	constructor(props) {
		super(props);
		// Colour mode sets the color setting for the entire app. 
		// Eg. 'light', 'dark'
		let colour_mode = 'light';
		if (window.localStorage.getItem('colour_mode') != null) colour_mode = window.localStorage.getItem('colour_mode');

		this.state = {
			width: document.documentElement.clientWidth,
			height: document.documentElement.clientHeight,
			is_show_background: true,
			is_show_loading: false,
			point_list: {},
			timestamp: new Date(),
			colour_mode: colour_mode,
			colours: Colours[colour_mode],

			// For console. Console will display console log when activated
			is_show_console: false,

			// Kaiwei 20210427 add a state to check if currently in MSM mode
			is_msm_mode: false,
			active_site: '',
			site_list: {},
		}

		this.content_area = React.createRef();

		// Screen resize event
		window.addEventListener('resize', this.updateWindowDimensions);

		// Create Receiver
		this.receiver = new App_Receiver();

		// Check Lanaguage and set the app languagae
		let lang = window.localStorage.getItem('language');
		if (lang != null && lang != '') this.receiver.setLanguage({ 'lang': lang });

		// variable to track if app is open for the first time
		//this.is_first_time_open = true;
	}

	updateWindowDimensions = () => {
		let width = 0;
		let height = 0;

		if (this.receiver.is_mobile) {
			width = document.documentElement.clientWidth;
			height = document.documentElement.clientHeight;
		} else {
			width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
			height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
		}

		this.setState({ width: width, height: height });

		var elem = document.getElementById('data');
		if(!isEmpty(elem)) elem.scrollTop = elem.scrollHeight;
	}

	/*handleSetNotFirstTime = () =>{
		this.is_first_time_open = false;
		window.localStorage.setItem('is_first_time_open', 'false')
	}*/

	hideBackground = () => {
		this.setState({ is_show_background: false });
	}

	showBackground = () => {
		this.setState({ is_show_background: true })
	}

	showLoading = () => {
		this.setState({ is_show_loading: true })
	}

	hideLoading = () => {
		this.setState({ is_show_loading: false })
	}

	showToast = (msg, timeout, height) => {
		this.content_area.current.switch_content.current.setState({ is_show_toast: true, toast_message: msg, toast_height: height, });
		// toast is displayed until hideToast is called
		if (timeout != null) setTimeout(this.hideToast, timeout);
	}

	hideToast = () => {
		this.content_area.current.switch_content.current.setState({ is_show_toast: false, toast_message: '', toast_height: null });
	}

	changeColourMode = (new_colour_mode) => {
		this.setState({
			colour_mode: new_colour_mode,
			colours: Colours[new_colour_mode],
		});

		window.localStorage.setItem('colour_mode', new_colour_mode);
	}

	onLogin = (is_logged_in, param) => {
		this.hideLoading();
		if (is_logged_in) this.content_area.current.content_handler('Dashboard', param);
	}

	cos = (cos_info) => {
		// For Hotel unit_mange
		if (cos_info.unit_manage != null) {
			let guest_room_cos = cos_info.unit_manage;
			if (this.content_area.current.switch_content.current.ref.current.updateRoomDetails != null) {
				this.content_area.current.switch_content.current.ref.current.updateRoomDetails(guest_room_cos);
			}
		} else if (!isEmpty(this.state.point_list)) {
			let point_id_list = Object.keys(cos_info);
			let new_point_list = JSON.parse(JSON.stringify(this.state.point_list));
			for (let id of point_id_list) {
				if (new_point_list[id] != null) Object.assign(new_point_list[id], cos_info[id]);
			}

			this.setState({ point_list: new_point_list })
		}
	}

	openConsole = () => {
		this.setState({
			is_show_console: true,
		})
	}

	closeConsole = () => {
		this.setState({
			is_show_console: false,
		})
	}

	setMSMMode(is_msm_mode) {
		this.setState({
			is_msm_mode: is_msm_mode,
		})
	}

	rcvMSMSiteStat = (site_stat) => {
		if (!isEmpty(this.state.site_list)) {
			let site_id_list = Object.keys(site_stat);
			let new_site_list = JSON.parse(JSON.stringify(this.state.site_list));

			for (let id of site_id_list) {
				if (new_site_list[id] != null) Object.assign(new_site_list[id].stat, site_stat[id]);
			}

			this.setState({ site_list: new_site_list })
		}
	}

	render() {
		let loading_width = this.state.width * 0.2;
		if (loading_width > 100) loading_width = 100;
		let loading_left = (this.state.width - loading_width) / 2;

		return (
			<div id='top-page' style={{ height: this.state.height, backgroundColor: this.state.is_show_background ? this.state.colours.background : 'unset', }}>
				<Content_Area
					ref={this.content_area}
					receiver={this.receiver}
					width={this.state.width}
					height={this.state.height}
					colours={this.state.colours}
					is_mobile={this.receiver.is_mobile}
				/>
				<img src={loading} alt="Loading gif"
					style={{
						display: this.state.is_show_loading ? 'block' : 'none',
						position: 'absolute',
						top: (this.state.height - 70) / 2,
						textAlign: 'center',
						marginLeft: loading_left,
						width: loading_width,
						verticalAlign: 'middle',
					}}
				/>
				{/*}<Console 
					is_show_console={this.state.is_show_console}
					width={this.state.width}
					height={this.state.height}
					closeConsole={this.closeConsole}
				/>*/}
			</div>
		)
	}
}
